import './assets/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';

import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Chart from 'primevue/chart';
import Divider from 'primevue/divider';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import ProgressSpinner from 'primevue/progressspinner';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faChartSimple,
  faHouse,
  faHeadset,
  faGear,
  faArrowRightFromBracket,
  faPiggyBank,
  faQuestion,
  faSolarPanel,
  faLeaf,
  faUser,
  faCloud,
  faCloudSun,
  faSun,
  faCloudShowersHeavy,
  faCloudBolt,
  faMoon,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faChartSimple,
  faHouse,
  faHeadset,
  faGear,
  faArrowRightFromBracket,
  faPiggyBank,
  faQuestion,
  faSolarPanel,
  faLeaf,
  faUser,
  faCloud,
  faCloudBolt,
  faCloudShowersHeavy,
  faCloudSun,
  faMoon,
  faSun,
  faQuestion,
);

import App from './App.vue';
import router from './router';
import SelectButton from 'primevue/selectbutton';
import Skeleton from 'primevue/skeleton';
import Message from 'primevue/message';

const app = createApp(App);

import * as Sentry from '@sentry/vue';
if(import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

app.use(createPinia());
app.use(router);
app.component('FontAwesomeIcon', FontAwesomeIcon);

const customPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{amber.50}',
      100: '{amber.100}',
      200: '{amber.200}',
      300: '{amber.300}',
      400: '{amber.400}',
      500: '{amber.500}',
      600: '{amber.600}',
      700: '{amber.700}',
      800: '{amber.800}',
      900: '{amber.900}',
      950: '{amber.950}',
    },
  },
});

app.use(PrimeVue, {
  theme: {
    preset: customPreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark-mode',
      cssLayer: false,
    },
  },
});
app.component('SelectButton', SelectButton);
app.component('Accordion', Accordion);
app.component('AccordionPanel', AccordionPanel);
app.component('AccordionHeader', AccordionHeader);
app.component('AccordionContent', AccordionContent);
app.component('InputText', InputText);
app.component('Button', Button);
app.component('Card', Card);
app.component('Chart', Chart);
app.component('Divider', Divider);
app.component('Select', Select);
app.component('FloatLabel', FloatLabel);
app.component('ProgressSpinner', ProgressSpinner);
app.component('Skeleton', Skeleton);
app.component('Message', Message);

app.mount('#app');
